import { IUserPreferences } from 'models/user/userpreferences';
import { imgSrcAttributes, thumbUrl } from 'helpers/common';
import * as React from 'react';
import { IShopCard } from 'models/shop/shopcard';
import renderIcon from 'helpers/renderIcon';
import { IOfficeMember } from 'models/shop/members';

interface IProps {
	className?: string;
	onClick?: () => void;
	onMouseOver?: () => void;
	onMouseOut?: () => void;
	imageUrl?: string;
	title?: string;
	name?: string;
	item?: IUserPreferences | IShopCard | IOfficeMember;
	customIcon?: JSX.Element;
	fromShop?: boolean;
}

const AvatarSmall = (props: IProps) => {
	const { item, customIcon, fromShop } = props;
	let { name, imageUrl } = props;
	const forwardAttrs = {};
	const forwardNames: Array<keyof IProps> = ['onClick', 'onMouseOver', 'onMouseOut', 'title'];
	if (item) {
		if (!name && item.name) {
			name = item.name;
		}
		if (!name && 'givenName' in item && 'familyName' in item) {
			name = item.givenName + ' ' + item.familyName;
		}
		if (!imageUrl && 'profilePicture' in item) {
			imageUrl = item.profilePicture;
		}
		if (!imageUrl && 'picture' in item) {
			imageUrl = item.picture;
		}
	}
	let icon = renderIcon('pfp_default');
	if ((item && 'ownerId' in item) || fromShop) {
		icon = renderIcon('pfp_salon');
	}
	if (customIcon) {
		icon = customIcon;
	}
	for (const attrName of forwardNames) {
		if (props[attrName]) {
			forwardAttrs[attrName] = props[attrName];
		}
	}
	let className = 'avatarSmall ' + (props.className || '');
	if (props.onClick) {
		className += ' interactive';
	}
	return (
		<figure
			{...forwardAttrs}
			className={className}
			style={imageUrl ? { backgroundImage: `url(${thumbUrl(imageUrl, 'small')})`, textIndent: '400px' } : undefined}
		>
			{imageUrl ? <img {...imgSrcAttributes(thumbUrl(imageUrl, 'small'))} alt={name} /> : icon}
			<span>{name && typeof name === 'string' ? String(name).substring(0, 1) : null}</span>
		</figure>
	);
};

export { AvatarSmall };
